import livaLogo from "../assets/images/ebridge-liva.png";
import omaniLogo from "../assets/images/ebridge-omani.png";
import almadLogo from "../assets/images/ebridge-almad.png";
import newindLogo from "../assets/images/ebridge-newind.png";
import dhofarLogo from "../assets/images/ebridge-dhofar.png";

export const EBRIDGE_COMPANIES = {
  LIVA: { name: "Liva Insurance", name_ar: "ليفا للتأمين", image: livaLogo },
  OMANI: { name: "Oman United Insurance", name_ar: "عمان للتأمين", image: omaniLogo },
  ALMAD: { name: "Al Madina Insurance", name_ar: "المدينة للتأمين", image: almadLogo },
  NEWIND: { name: "New India Assurance", name_ar: "نيو انديا", image: newindLogo },
  DHOFAR: { name: "Dhofar Insurance", name_ar: "ظفار للتأمين", image: dhofarLogo },
};

const formatRopDate = (dateStr) => {
  if (!dateStr) return null;
  const s = String(dateStr).replace(/-/g, "");
  if (s.length === 8) {
    return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
  }
  return dateStr;
};

const formatJsDate = (date) => {
  if (!date) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  return d.toISOString().split("T")[0];
};

const getRopVehicleTradePrice = (vehicleData) => {
  const vehicleDescription =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.result?.vehicle_description
      ?.Vehicle_Description;
  const firstVehicle = Array.isArray(vehicleDescription)
    ? vehicleDescription[0]
    : vehicleDescription;
  return firstVehicle?.trade_price;
};

export const buildEbridgeQuoteRequest = (
  ropRequestData,
  vehicleData,
  valuationData
) => {
  const vehicleInfo =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.VehicleInfo;
  const licenseInfo =
    vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
      ?.GetLicenseInfoResult;
  const formData = ropRequestData?.form_data;
  const productDetails = ropRequestData?.product_details;

  const coverType =
    productDetails?.sub_product_id === 21 ? "Comprehensive" : "ThirdParty";

  return {
    plateNumber: vehicleInfo?.PlateNumber || "",
    plateCode: vehicleInfo?.PlateCode || "",
    nationalId: licenseInfo?.LicenseNumber || "",
    customerName: "Vehicle Owner",
    dateOfBirth: formatRopDate(licenseInfo?.DateofBirth) || "",
    mobileNo: formData?.mobile_no || "",
    vehicleValue:
      coverType === "Comprehensive"
        ? String(parseFloat(valuationData) || 1)
        : String(parseFloat(getRopVehicleTradePrice(vehicleData)) || 1),
    licenseNumber: licenseInfo?.LicenseNumber || "",
    licenseIssueDate: formatRopDate(licenseInfo?.DateFirstIssued) || "",
    licenseExpiryDate: formatRopDate(licenseInfo?.DateofExpiry) || "",
    policyStartDate: formatJsDate(formData?.start_date) || "",
    policyEndDate: formatJsDate(formData?.end_date) || "",
    address: "Oman",
    coverType,
  };
};

const processPlansCovers = (plans) => {
  if (!plans || !plans.length) return { included_covers: [], optional_covers: [] };
  const covers = plans[0]?.covers || [];
  const included_covers = covers.filter((c) => c.isIncluded);
  const optional_covers = covers
    .filter((c) => !c.isIncluded)
    .map((c) => ({ ...c, isSelected: false }));
  return { included_covers, optional_covers };
};

export const prepareEbridgeInsuranceCardData = (quotes, productDetails) => {
  if (!quotes || !quotes.length) return [];
  return quotes
    .filter((q) => q.readyForPolicy)
    .map((quote, index) => {
      const company = EBRIDGE_COMPANIES[quote.targetCode] || {
        name: quote.targetCode,
        name_ar: quote.targetCode,
      };
      const { included_covers, optional_covers } = processPlansCovers(quote.plans);
      return {
        object_id: index,
        product_id: productDetails?.product_id || 1,
        sub_product_id: productDetails?.sub_product_id,
        company_code: quote.targetCode,
        company_name: company.name,
        company_name_ar: company.name_ar,
        company_image: company.image || null,
        premium_value: quote.estimatedPremium,
        base_price: quote.estimatedPremium,
        premium_currency: "OMR",
        quote_reference: quote.quoteReferenceNumber,
        ready_for_policy: quote.readyForPolicy,
        requires_referral: quote.requiresReferral,
        included_covers,
        optional_covers,
        is_ebridge: true,
      };
    });
};
